import uuidv4 from "uuidv4"

export default {
  initDevice() {
    return Promise.resolve()
  },
  getDeviceId() {
    let deviceId = localStorage.getItem("deviceId")
    if (deviceId === null) {
      deviceId = uuidv4()
      localStorage.setItem("deviceId", deviceId)
    }
    return deviceId
  }
}
